import './peacecenter/style';
import FormStructure from './peacecenter/form_structure';

export default FormStructure;